import _ from 'lodash';
import {
  Stack,
  TableCell as MuiTableCell,
  Typography,
  Checkbox,
  TableRow,
  TableBody,
} from '@mui/material';
import Info from '../../table/components/Info.component';
import Detail from '../../table/components/Detail.component';
import UploadImageProduct from '../../../common/UploadImageProduct.component';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { STATUS_ENABLE_SEND_LOGBOOK } from '../../../../module/listItem/conf/Data.conf';
import EditItem from '../../update/EditItem.component';
import MoveItem from '../../delete/MoveItem.component';
import DeleteItem from '../../delete/DeleteItem.component';

const TableCell = ({ children, width }) => {
  return (
    <MuiTableCell sx={{ paddingTop: 0.5, paddingBottom: 0.5 }} width={width}>
      {children}
    </MuiTableCell>
  );
};

const TableBodyItemsEditable = ({
  checked,
  onSelectItem = () => {},
  hasCheckbox = true,
  setSuccessEdit = () => {},
  isSelectable = false,
  hasAvailable = false,
  hasStock = false,
  module,
  data,
  statusLogbook,
  moveDelete = false,
}) => {
  return (
    <TableBody>
      {data?.map((item) => (
        <TableRow key={item?.id}>
          {hasCheckbox && (
            <TableCell>
              <Checkbox
                checked={checked?.[item?.id] || false}
                onChange={() => {
                  onSelectItem({
                    id: item?.id,
                    status: _.has(checked, item?.id)
                      ? !checked?.[item?.id]
                      : true,
                    available: _.get(item, 'attributes.available'),
                  });
                }}
                disabled={
                  isSelectable
                    ? false
                    : _.isEmpty(
                        _.find(
                          STATUS_ENABLE_SEND_LOGBOOK,
                          (status) => item?.attributes?.available === status
                        )
                      )
                }
              />
            </TableCell>
          )}

          <TableCell>
            <Stack spacing={1}>
              <Detail item={item} />
              <Info item={item} name='note' label='Note' />
              <Info item={item} name='internal_note' label='Internal Note' />
            </Stack>
          </TableCell>
          <TableCell>
            <UploadImageProduct
              remainingFiles={item?.attributes?.attachment?.data?.map(
                (file) => file.id
              )}
              item={item}
            />
          </TableCell>
          <TableCell>
            <Stack direction={'row'} spacing={1}>
              <Typography>{item?.attributes?.quantity || '-'}</Typography>
              <Typography>{item?.attributes?.quantity_type}</Typography>
            </Stack>
          </TableCell>

          {hasAvailable && (
            <TableCell>
              <Typography>{item?.attributes?.available || '-'}</Typography>
            </TableCell>
          )}

          {hasStock && (
            <TableCell>
              {!!item?.attributes?.stock_available && (
                <CheckCircleIcon color='success' />
              )}
            </TableCell>
          )}
          <TableCell>
            <Stack direction={'row'}>
              <EditItem
                item={item}
                setSuccessEdit={setSuccessEdit}
                module={module}
              />
              {moveDelete ? (
                <MoveItem
                  module={module}
                  item={item}
                  statusLogbook={statusLogbook}
                  data={data}
                  handleSuccess={setSuccessEdit}
                />
              ) : (
                <DeleteItem
                  module={module}
                  item={item}
                  data={data}
                  handleSuccess={setSuccessEdit}
                />
              )}
            </Stack>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

export default TableBodyItemsEditable;
